export const getAccount = (state) => state.account;
export const getApplication = (state) => state.application;
export const getOrganisation = (state) => state.organisation;
